<!-- Metrics Cards -->
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
  <div *ngFor="let metric of metrics" class="p-6 bg-white rounded-xl border border-solid border-sky-blue">
    <div class="text-3xl sm:text-4xl lg:text-5xl font-bold text-neptune-default tvd-value-text">
      <div class="{{metric?.id}}-mod-value tvd-drillin-value">
        <ng-container *ngIf="metric.isCurrency && metric.modifiedValue !== 'N/A' && metric.modifiedValue !== null">
          {{currencySymbol}}{{ metric.modifiedValue | number }}
        </ng-container>
        <ng-container *ngIf="!metric.isCurrency && (metric.modifiedValue !== 'N/A' && metric.modifiedValue !== null)">
          {{metric.modifiedValue | number}}
        </ng-container>
        <ng-container *ngIf="metric.modifiedValue === 'N/A' || metric.modifiedValue === null">
          N/A
        </ng-container>
      </div>
      <div *ngIf="shouldShowDefault(metric)" class="{{metric?.id}}-org-value pt-6 text-neptune-xl font-medium leading-6 text-neptune-neutral">
        Default - <span *ngIf="metric.isCurrency">{{currencySymbol}}</span>
        {{metric.originalValue | number}}
      </div>
    </div>
    <div class="{{metric?.id}}-text text-base sm:text-lg text-neptune-neutral uom-text pt-6">
      {{ metric.title }}
    </div>
  </div>
</div>

